import { IGetState, TBoardId, TKanbanCardProperty } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { boardUpdateMeta } from './boardUpdateMeta';

export const boardSetDefaultCardPreviewHiddenProperties = (
    boardId: TBoardId,
    defaultCardPreviewHiddenProperties: TKanbanCardProperty[],
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(boardUpdateMeta(boardId, { defaultCardPreviewHiddenProperties }));
    };
    return action;
}
